import { IonApp, IonRouterOutlet, setupIonicReact } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import Home from './pages/Home';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';

/* Theme variables */
import AccountPage from './pages/AccountPage';
import CardsPage from './pages/CardsPage';
import PasswordResetPage from './pages/PasswordResetPage';
import PaymentsPage from './pages/PaymentsPage';
import RegisterPage from './pages/RegisterPage';
import './theme/variables.css';
import './theme/main.css';
import AccountPasswordPage from './pages/AccountPasswordPage';
import AccountQuestionsPage from './pages/AccountQuestionsPage';
import FeedbackPage from './pages/FeedbackPage';
import UnregisterPage from './pages/UnregisterPage';
import CardValuePage from './pages/CardValuePage';
import CardOptionsPage from './pages/CardOptionsPage';
import CardHistoryPage from './pages/CardHistoryPage';
import CardPassesPage from './pages/CardPassesPage';
import CardAutoloadPage from './pages/CardAutoloadPage';
import CardsAddPhysicalPage from './pages/CardsAddPhysicalPage';
import CardsAddVirtualPage from './pages/CardsAddVirtualPage';
import { PrivateRoute } from './PrivateRoute';
import { AuthProvider } from './EnhancedAuth';
import { PostMessageReceiver } from './PostMessageReceiver';
import CardInformationPage from './pages/CardInformationPage';
import CardFareCappingPage from './pages/CardFareCappingPage';
import UrpassPage from './pages/UrpassPage';
import UrpassaddPage from './pages/UrpassaddPage';
import UrpassviewPage from './pages/UrpassviewPage';
import { LoadingProvider } from './context/LoadingContext';
import WeglotProvider from './context/WeglotContext';
import {InstitutionsRegisterPageLink} from "./pages/InstitutionsRegisterPageLink";
import {InstitutionsRegisterPageList} from "./pages/InstitutionsRegisterPageList";

setupIonicReact();

const App: React.FC = () => {
  return (
    <AuthProvider>
      <WeglotProvider>
        <PostMessageReceiver>
          <IonApp>
            <LoadingProvider>
              <IonReactRouter>
                <IonRouterOutlet animated={false}>
                  <Route path="/" exact={true}>
                    <Redirect to="/home" />
                  </Route>
                  <Route path="/home" exact={true}>
                    <Home />
                  </Route>
                  <Route path="/password-reset" exact={true}>
                    <PasswordResetPage />
                  </Route>
                  <Route path="/register-user" exact={true}>
                    <RegisterPage />
                  </Route>
                  <Route path="/account">
                    <PrivateRoute>
                      <AccountPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/accountpassword">
                    <PrivateRoute>
                      <AccountPasswordPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/accountquestions">
                    <PrivateRoute>
                      <AccountQuestionsPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/unregister">
                    <PrivateRoute>
                      <UnregisterPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/payments">
                    <PrivateRoute>
                      <PaymentsPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/feedback">
                    <PrivateRoute>
                      <FeedbackPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/cards">
                    <PrivateRoute>
                      <CardsPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/cardsaddphysical">
                    <PrivateRoute>
                      <CardsAddPhysicalPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/cardsaddvirtual">
                    <PrivateRoute>
                      <CardsAddVirtualPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/card/:cardid/value">
                    <PrivateRoute>
                      <CardValuePage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/card/:cardid/options">
                    <PrivateRoute>
                      <CardOptionsPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/card/:cardid/history">
                    <PrivateRoute>
                      <CardHistoryPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/card/:cardid/information">
                    <PrivateRoute>
                      <CardInformationPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/card/:cardid/autoload">
                    <PrivateRoute>
                      <CardAutoloadPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/card/:cardid/passes">
                    <PrivateRoute>
                      <CardPassesPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/card/:cardid/fares">
                    <PrivateRoute>
                      <CardFareCappingPage />
                    </PrivateRoute>
                  </Route>
                  <Route exact path="/card/:cardid/institution">
                    <PrivateRoute>
                      <InstitutionsRegisterPageList />
                    </PrivateRoute>
                  </Route>
                  <Route path="/card/:cardid/institution/register">
                    <PrivateRoute>
                      <InstitutionsRegisterPageLink />
                    </PrivateRoute>
                  </Route>
                  <Route path="/urpass">
                    <PrivateRoute>
                      <UrpassPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/urpassadd">
                    <PrivateRoute>
                      <UrpassaddPage />
                    </PrivateRoute>
                  </Route>
                  <Route path="/urpassview/:agencyid/:ticketid">
                    <PrivateRoute>
                      <UrpassviewPage />
                    </PrivateRoute>
                  </Route>
                </IonRouterOutlet>
              </IonReactRouter>
            </LoadingProvider>
          </IonApp>
        </PostMessageReceiver>
      </WeglotProvider>
    </AuthProvider>
  );
};

export default App;
